module.exports = __webpack_public_path__ + "static/media/frame.8cb0e2fd.svg";